<template>
  <el-row>
    <el-form :model="peaCore" :rules="rules" ref="summaryForm" label-width="160px" class="summaryForm">
      <el-col :span="24">
        <h2>Summary</h2>
        <el-row :gutter="20">
          <el-col :lg="6">
            PEA ID:  {{peaCore.id}}
          </el-col>
          <el-col :lg="18">
            <div>Status:  <status-icon :statusId="peaCore.peaStatusId"></status-icon> {{peaCore.peaStatus}}</div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :lg="6">
            Owner:  {{peaCore.createdByFullName}}
          </el-col>
          <el-col :lg="12">
            <el-button v-if="showReopenBtn"
              type="primary"
              icon="el-icon-refresh-left"
              style="margin: 5px 0 5px 0"
              @click="reopenPEA()">
              Re-open
            </el-button>
          </el-col>
          <el-col :lg="showReopenBtn ? { span: 4, offset: 0 } : { span: 4, offset: 12 } " >
            <div v-if="!printing">
              <el-popover
                ref="email"
                placement="top-start"
                trigger="hover">
                <div>
                  Email this PEA
                </div>
              </el-popover>
              <el-button style="float: left; margin-right: 10px;" circle icon="el-icon-message" v-popover:email @click="promptEmail()"></el-button>
              <el-popover
                ref="print"
                placement="top-start"
                trigger="hover">
                <div>
                  Print this PEA
                </div>
              </el-popover>
              <el-button circle icon="el-icon-printer" v-popover:print @click="reloadPrint()"></el-button>
            </div>
          </el-col>
        </el-row>
        <hr/>
        <el-row :gutter="20">
          <el-col :lg="9">
            <el-form-item label="PEA Name" prop="peaName">
              <el-input :disabled="disabled" type="textarea" v-model="peaCore.peaName" :minlength="3" :maxlength="100" :autosize="{ minRows: 1, maxRows: 2}"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="1">
            <tool-tip-popup :text="nameToolTip" :showLink="true"></tool-tip-popup>
          </el-col>
          <el-col :lg="1" :md="0"><div>&nbsp;</div></el-col>

          <el-col :lg="8">
            <el-form-item label="Check if Budgeted" prop="capitalBudgetType">
              <el-checkbox :disabled="disabled" v-model="peaCore.capitalBudgetType"  name="budgeted"></el-checkbox>
            </el-form-item>
            <!-- v-if only show when capitalBudgetType is true/Budgeted -->
            <div v-if="peaCore.capitalBudgetType === true || peaCore.capitalBudgetType === 'true'">
              <el-form-item label="Capital Budget ID" prop="capitalBudget">
                <el-input :disabled="disabled" v-model="peaCore.capitalBudget" :minlength="3" :maxlength="50"></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :lg="1">
            <tool-tip-popup :text="captialBudgetToolTip" :showLink="true"></tool-tip-popup>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :lg="9">
            <el-form-item label="Reason" prop="reason">
              <reason-dropdown :disabled="disabled" v-model="peaCore.reason" :inputModel="peaCore.reason"></reason-dropdown>
            </el-form-item>
          </el-col>
          <el-col :lg="1">
            <tool-tip-popup :text="reasonToolTip" :showLink="true"></tool-tip-popup>
          </el-col>
          <el-col :lg="1" :md="0"><div>&nbsp;</div></el-col>

          <el-col :lg="9">
            <el-form-item label="Department(s)" prop="peaDepartmentIds">
              <!-- v-if is to suppress warning on initial load -->
              <department-dropdown :disabled="disabled" :multiple="true" v-model="peaCore.peaDepartmentIds" :inputModel="peaCore.peaDepartmentIds"></department-dropdown>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :lg="9">
            <el-form-item label="Division" prop="peaDivisionId">
              <division-dropdown :disabled="disabled" v-model="peaCore.peaDivisionId" :inputModel="peaCore.peaDivisionId" ></division-dropdown>
            </el-form-item>
          </el-col>
          <el-col :lg="1">
            <tool-tip-popup text="Note: Division is a main determinate for who approves this PEA."></tool-tip-popup>
          </el-col>
          <el-col :lg="1" :md="0"><div>&nbsp;</div></el-col>
          <el-col :lg="8">
            <el-form-item label="Cost Center" prop="costCenter">
              <el-input :disabled="disabled" v-model="peaCore.costCenter"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="1">
            <tool-tip-popup text="Note: Cost Center is a value associated with the department in which the expense will be charged."></tool-tip-popup>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :lg="4">
            <el-form-item label="Emergency" prop="isEmergency">
              <el-checkbox :disabled="disabled" v-model="peaCore.isEmergency" @change="callDateValidation"></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col class="summaryEmergencyNote" :lg="12">
              <small><strong>Note: Only check this if this PEA is urgent and requires approval within the next 2 weeks.
                <br>
                Emergency PEAs will be subject to additional scrutiny.
              </strong></small>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :lg="4">
            <el-form-item label="Sustainability Impact" prop="hasSustainabilityImpact">
              <el-checkbox :disabled="disabled" v-model="peaCore.hasSustainabilityImpact"></el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <br>
        <el-row :gutter="20">
          <el-col :lg="17">
            <div v-if="!printing">
              <el-form-item label="Description" prop="peaDescription">
                <ckeditor ref="description" v-model="peaCore.peaDescription" :readOnlyMode="disabled" :config="editorConfig"></ckeditor>
              </el-form-item>
            </div>
            <div v-if="printing">
              <el-form-item label="Description" prop="peaDescription">
                <p v-html="peaCore.peaDescription"></p>
              </el-form-item>
            </div>
          </el-col>
          <el-col :lg="1">
            <tool-tip-popup text="Note: Please describe the project in reasonable detail. Further supporting documents can be attached in the Documents section below."></tool-tip-popup>
          </el-col>
        </el-row>
        <br/>
        <el-row :gutter="20">
          <el-col :lg="6">
            <el-form-item label="Project Start Date" prop="projectStartDate">
              <el-date-picker :disabled="disabled"
              id="idStart"
              v-model="peaCore.projectStartDate"
              type="date"
              placeholder="Pick a date"
              :picker-options="startDatePickerOptions"
              @change="updateProjectStartDate">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :lg="4">
          <tool-tip-popup :text="projectStateDateToolTip" :showLink="true"></tool-tip-popup>
        </el-col>
        <el-col :lg="6">
          <el-form-item label="Project End Date" prop="projectEndDate">
            <el-date-picker :disabled="disabled"
            v-model="peaCore.projectEndDate"
            id="idEnd"
            type="date"
            placeholder="Pick a date"
            :picker-options="endDatePickerOptions"
            ref="endDatePicker">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :lg="4">
        <tool-tip-popup :text="projectEndDateToolTip" :showLink="true"></tool-tip-popup>
      </el-col>
    </el-row>
  </el-col>
</el-form>
</el-row>
</template>

<script>
import store from '../../state/store.js'
import helperMethods from '@/components/utility/helperMethods.js'
import {divisionList} from '@/components/utility/divisionList.js'
import CKEditor from 'ckeditor4-vue'
export default {
  name: 'pea-summary',
  components: {
    // Use the <ckeditor> component in this view.
    ckeditor: CKEditor.component
  },
  mixins: [divisionList],
  props: {
    peaId: {
      default: 0
    },
    disabled: {
      default: false
    },
    printing: {
      default: false
    },
    canReopenPEA: {
      default: false
    }
  },
  data () {
    var validateCapitalBudget = (rule, value, callback) => {
      if (this.peaCore.capitalBudgetType === true) {
        if (value === '' || value === null) {
          callback(new Error('Please input Capital Budget'))
        } else {
          if (value.length < 3 || value.length > 75) {
            callback(new Error('Length should be 3 to 75 characters'))
          }
        }
      }
      callback()
    }
    // date for project start must be more than 2 weeks away UNLESS an emergency
    // end date must be after start date
    var ValidateEndDate = (rule, value, callback) => {
      if (!this.disabled) {
        // check other field validation but avoid infinite loop
        if (this.datePass) {
          this.datePass = false
          this.$refs.summaryForm.validateField('projectStartDate')
        }
        this.datePass = true
        if ((helperMethods.convertDateToNumber(this.peaCore.projectStartDate) > helperMethods.convertDateToNumber(value))) {
          callback(new Error('End date must be on or after the start date.'))
        }
      }
      callback()
    }
    var ValidateStartDate = (rule, value, callback) => {
      if (!this.disabled) {
        // check other field validation but avoid infinite loop
        if (this.datePass) {
          this.datePass = false
          this.$refs.summaryForm.validateField('projectEndDate')
        }
        this.datePass = true
        if (helperMethods.convertDateToNumber(value) <= helperMethods.convertDateToNumber(Date.now())) {
          callback(new Error('Project start date must be after current date.'))
        }
        if (!this.peaCore.isEmergency) {
          if (value.getTime() < (Date.now() + 13 * 24 * 60 * 60 * 1000)) {
            callback(new Error('A non-emergency PEA needs to start at least 2 weeks from the current date.'))
          }
        }
        if (helperMethods.convertDateToNumber(value) > helperMethods.convertDateToNumber(this.peaCore.projectEndDate)) {
          callback(new Error('Project start date must be on or before end date.'))
        }
      }
      callback()
    }
    return {
      editorConfig: {
        htmlEncodeOutput: true
      },
      isDeleted: false,
      captialBudgetToolTip: 'Note: A Capital Budget ID is required if the PEA is budgeted.  <br/> Capital Budget ID is alpha-numerical and should begin with the last two digits of the year.',
      nameToolTip: 'Note: Try to make the name a title or short description of the PEA which will be meaningful for you and others to identify it within the complete set of PEAs. <br/> Maximum length is 100 characters.',
      reasonToolTip: 'Note: This will be used to report on PEA expenditure by reason. <br/> If your PEA is covered by more than one reason then select the main reason.',
      projectStateDateToolTip: 'Note: A non-emergency PEA needs to start at least 2 weeks from the current date. <br/> PEAs for projects commencing in less than two weeks are not acceptable unless they are marked as an emergency.',
      projectEndDateToolTip: 'Note: The Project End Date must be the same as or after the start date. <br/> Please return to the PEA and update the final expenditure when it is complete.',
      datePass: true,
      peaCore: {
        peaName: '',
        peaStatusId: 1,
        peaDivisionId: '',
        reason: '',
        costCenter: '',
        peaDescription: '',
        isEmergency: false,
        projectStartDate: new Date(Date.now()),
        projectEndDate: new Date(Date.now()),
        capitalBudget: '',
        capitalBudgetType: false,
        createdByFullName: '',
        peaDepartmentIds: []
      },
      departmentList: Array,
      divisionList: Array,
      rules: {
        peaName: [
          { required: true, message: 'Please input PEA name', trigger: 'blur' },
          { min: 3, max: 1750, message: 'Length should be 3 to 1750 characters', trigger: 'blur' }
        ],
        reason: [
          { required: true, message: 'Please select Reason', trigger: 'visible-change' }
        ],
        peaDivisionId: [
          { type: 'number', required: true, message: 'Please pick a Division', trigger: 'visible-change' }
        ],
        projectStartDate: [
          { type: 'date', required: true, message: 'Please pick a Date', trigger: 'change' },
          { type: 'date', validator: ValidateStartDate, required: true, trigger: 'change' }
        ],
        projectEndDate: [
          { type: 'date', required: true, message: 'Please pick a Date', trigger: 'change' },
          { type: 'date', validator: ValidateEndDate, required: true, trigger: 'change' }
        ],
        peaDepartmentIds: [
          { type: 'array', required: true, message: 'Please select at least one Department', trigger: 'visible-change' }
        ],
        capitalBudget: [
          { validator: validateCapitalBudget, trigger: 'change' }
        ],
        costCenter: [
          { required: true, message: 'Please input Cost Center', trigger: 'change' },
          { max: 50, message: 'Please enter value with fewer than 50 characters', trigger: 'change' }
        ],
        peaDescription: [
          { required: true, message: 'Please Input a Description', trigger: 'blur' }
        ]
      },
      endDatePickerOptions: {
        disabledDate (time) {
          // set it for not less than today
          return Date.now() >= (time.getTime() + 3600 * 1000 * 24)
        }
      },
      startDatePickerOptions: {
        disabledDate (time) {
          // set it for not less than today
          return Date.now() >= (time.getTime() + 3600 * 1000 * 24)
        }
      }
    }
  },
  computed: {
    showReopenBtn () {
      return this.peaCore.peaStatus === 'Complete' && this.canReopenPEA
    }
  },
  methods: {
    setPEADelete () {
      this.isDeleted = !this.isDeleted
    },
    promptEmail () {
      var subject = 'PEA ' + this.peaId
      var body = window.location.href
      var uri = 'mailto:?subject='
      uri += subject
      uri += '&body='
      uri += encodeURIComponent(body)
      var mail = document.createElement('a')
      mail.href = uri
      document.body.appendChild(mail)
      mail.click()
    },
    reloadPrint () {
      window.open('/pea/printPEA/' + this.peaId, '_blank')
    },
    checkSummaryValid () {
      this.$refs['summaryForm'].validate((valid) => {
        if (valid) {
          this.$parent.$emit('peaSummaryValidation', true)
        } else {
          this.$parent.$emit('peaSummaryValidation', false)
          helperMethods.showNotification(this.$parent, 'Invalid Summary requirements', 'Please check Summary section for invalid inputs.', 'warning', 30000, 'Please check form for invalid inputs.')
        }
      })
    },
    callDateValidation () {
      this.$refs.summaryForm.validateField('projectStartDate')
    },
    summaryFormSubmit () {
      // eslint-disable-next-line
      if (this.peaId != 0) {
        if (this.peaCore.peaStatusId === 13) {
          return this.deletePEA()
        }
        return this.updatePEASummary()
      } else {
        return this.addPEASummary()
      }
    },
    fetchData () {
      var call = '/getPEASummary/' + this.peaId
      this.$axios.get(call).then(response => {
        this.peaCore = response.data
        // needs to be date object
        this.peaCore.projectStartDate = new Date(this.peaCore.projectStartDate)
        this.peaCore.projectEndDate = new Date(this.peaCore.projectEndDate)
        this.$emit('updateYears')
        this.$emit('fetchComplete')
      }).catch(response => {
        if (!this.isDeleted) {
          helperMethods.showNotification(this.$parent, 'Error retreiving PEA Summary Information', response.body, 'error', 30000)
          this.$emit('fetchComplete')
        }
      })
    },
    startUp () {
      // eslint-disable-next-line
      if (this.peaId != 0) {
        this.fetchData()
      } else {
        this.peaCore.createdByFullName = store.getters.fullName
      }
    },
    updateProjectStartDate () {
      this.$emit('updateYears')
    },
    deletePEA () {
      var call = '/deletePEA/' + this.peaId
      return new Promise((resolve, reject) => {
        this.$axios.post(call).then(response => {
          resolve(response)
        })
          .catch(response => {
            helperMethods.showNotification(this.$parent, 'Error deleting PEA', response.body, 'error', 30000)
            reject(response)
          })
      })
    },
    reopenPEA () {
      const call = '/reopenPEA/' + this.peaId
      this.$axios.post(call)
        .then(response => {
          helperMethods.showNotification(this.$parent, 'PEA Reopened!', response.body, 'success', 10000)
          this.$emit('reopened')
        })
        .catch(response => {
          helperMethods.showNotification(this.$parent, 'Error reopening PEA', response.body, 'error', 30000)
        })
    },
    updatePEASummary () {
      var call = '/updatePEASummary/' + this.peaId
      this.peaCore.projectStartDate = helperMethods.convertDatetoISO(this.peaCore.projectStartDate)
      this.peaCore.projectEndDate = helperMethods.convertDatetoISO(this.peaCore.projectEndDate)
      var currentStatusId = this.peaCore.peaStatusId
      var currentStatus = this.peaCore.peaStatus
      return new Promise((resolve, reject) => {
        this.$axios.post(call, this.peaCore).then(response => {
          this.peaCore.projectStartDate = new Date(this.peaCore.projectStartDate)
          this.peaCore.projectEndDate = new Date(this.peaCore.projectEndDate)
          this.peaCore.peaStatusId = response.data.peaStatusId
          this.peaCore.peaStatus = response.data.peaStatus
          resolve(response)
        })
          .catch(response => {
            this.peaCore.projectStartDate = new Date(this.peaCore.projectStartDate)
            this.peaCore.projectEndDate = new Date(this.peaCore.projectEndDate)
            this.peaCore.peaStatusId = currentStatusId
            this.peaCore.peaStatus = currentStatus
            helperMethods.showNotification(this.$parent, 'Error updating PEA Summary Information', response.body, 'error', 30000)
            reject(response)
          })
      })
    },
    addPEASummary () {
      var call = '/createPEASummary'
      this.peaCore.createdByUserId = this.$store.getters.userId
      this.peaCore.peaStatusId = 1
      this.peaCore.projectStartDate = helperMethods.convertDatetoISO(this.peaCore.projectStartDate)
      this.peaCore.projectEndDate = helperMethods.convertDatetoISO(this.peaCore.projectEndDate)
      // this promised handled by peaMain
      return new Promise((resolve, reject) => {
        this.$axios.post(call, this.peaCore).then(response => {
          this.peaCore.projectStartDate = new Date(this.peaCore.projectStartDate)
          this.peaCore.projectEndDate = new Date(this.peaCore.projectEndDate)
          this.peaCore.peaStatusId = response.data.peaStatusId
          this.peaCore.peaStatus = response.data.peaStatus
          resolve(response)
        })
          .catch(response => {
            this.peaCore.projectStartDate = new Date(this.peaCore.projectStartDate)
            this.peaCore.projectEndDate = new Date(this.peaCore.projectEndDate)
            this.peaCore.peaStatusId = response.data.peaStatusId
            this.peaCore.peaStatus = response.data.peaStatus
            helperMethods.showNotification(this.$parent, 'Error creating PEA', response.data, 'error', 30000)
            reject(response)
          })
      })
    }
  },
  created () {
    this.startUp()
  },
  watch: {
    // watch for route change - going from pea/4 to pea/0
    '$route': 'startUp'
  }
}
</script>

<style>

.datePicker label {
  width: auto !important;
}
.statusIcon {
  width: 27px;
  height: 27px;
}

  .el-date-editor.el-input {
    width: 100% !important;
    min-width: 150px
  }
</style>
